// supports multiple icons, colors, tooltips, disabled states, and click handlers

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

interface IconBtn {
  icon: string;
  tooltip?: string;
  disabled?: boolean | ((params: any) => boolean);
  color?: string;
  onClick?: (params: any) => void;
}

interface IconBtnParams extends ICellRendererParams {
  onClick?: (params: any) => void;
  icon?: string;
  tooltip?: string;
  disabled?: boolean | ((params: any) => boolean);
  color?: string;
  display?: string;
}

@Component({
    selector: 'app-ag-grid-icon-btns',
    template: `
    <div class="tw-flex tw-gap-2 tw-items-center">
      <button
        *ngFor="let item of icons"
        matTooltip="{{ item.tooltip }}"
        class="tw-bg-transparent tw-border-0 tw-p-2 tw-rounded-full tw-leading-[0px]"
        [ngClass]="{
          'tw-text-link-color-dynamic dark:hover:tw-bg-gray-900/20': item.color === 'primary',
          'tw-text-gray-400 dark:tw-text-gray-500': item.disabled,
          'hover:tw-bg-blue-100 dark:hover:tw-bg-blue-900 tw-text-blue-600 dark:tw-text-blue-400': !item.color || item.color === 'blue',
          'hover:tw-bg-red-100 dark:hover:tw-bg-red-900 tw-text-red-600 dark:tw-text-red-400': item.color === 'red',
          'hover:tw-bg-green-100 dark:hover:tw-bg-green-900 tw-text-green-600 dark:tw-text-green-400': item.color === 'green',
          'hover:tw-bg-yellow-100 dark:hover:tw-bg-yellow-900 tw-text-yellow-600 dark:tw-text-yellow-400': item.color === 'yellow',
          'hover:tw-bg-purple-100 dark:hover:tw-bg-purple-900 tw-text-purple-600 dark:tw-text-purple-400': item.color === 'purple',
          'hover:tw-bg-indigo-100 dark:hover:tw-bg-indigo-900 tw-text-indigo-600 dark:tw-text-indigo-400': item.color === 'indigo',
          'hover:tw-bg-pink-100 dark:hover:tw-bg-pink-900 tw-text-pink-600 dark:tw-text-pink-400': item.color === 'pink',
          'hover:tw-bg-orange-100 dark:hover:tw-bg-orange-900 tw-text-orange-600 dark:tw-text-orange-400': item.color === 'orange',
          'hover:tw-bg-teal-100 dark:hover:tw-bg-teal-900 tw-text-teal-600 dark:tw-text-teal-400': item.color === 'teal',
          'hover:tw-bg-gray-100 dark:hover:tw-bg-gray-900 tw-text-gray-600 dark:tw-text-gray-400': item.color === 'gray',
        }"
        (click)="onIconClick(item)"
        [disabled]="item.disabled">
        <mat-icon>{{ item.icon }}</mat-icon>
      </button>
    </div>
  `,
    styles: [],
    standalone: false
})
export class AgGridIconBtnsComponent implements ICellRendererAngularComp {
  icons: IconBtn[] = [];
  params: IconBtnParams;

  agInit(params: IconBtnParams): void {
    this.params = params;
    this.icons = [
      {
        icon: params.icon || 'download',
        tooltip: params.tooltip,
        disabled: params.disabled,
        color: params.color || 'blue',
        onClick: params.onClick,
      },
    ];

    // Set default color to blue if not specified and ensure color is always set
    this.icons = this.icons.map((icon) => ({
      ...icon,
      color: icon.color || 'blue',
      disabled: typeof icon.disabled === 'function' ? icon.disabled(this.params) : icon.disabled,
    }));
  }

  refresh(params: IconBtnParams): boolean {
    this.agInit(params);
    return true;
  }

  onIconClick(item: IconBtn): void {
    if (item.disabled) {
      return;
    }

    if (item.onClick) {
      item.onClick({ rowData: this.params.data });
    }
  }
}
